<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import AutoUpdateMixin from '@/mixins/auto-update';
export default {
  name: 'App',
  mixins: [AutoUpdateMixin],
  computed: {
    authorizedUserID() {
      return this.$store.state.authentication.userId;
    },
    currentPermissions() {
      return this.$store.getters.permissions;
    }
  },
  watch: {
    authorizedUserID(newUserID) {
      this.onAuthorizedUserIDChanged(newUserID);
    },
    currentPermissions(newPermissions, oldPermissions) {
      // Generate routes for side bar
      this.$store.dispatch('permission/generateRoutes', newPermissions);
    }
  },
  created() {
    this.$store.dispatch('language/getItems');
    this.onAuthorizedUserIDChanged(this.authorizedUserID);
  },
  methods: {
    onAuthorizedUserIDChanged(newUserID) {
      if (newUserID) {
        this.$store.dispatch('option/fetchAllOptions');
        this.$store.dispatch('configuration/getItems');
        this.$store.dispatch('getUserInfo', {}).then(() => {});
      }
    }
  }
};
</script>
